import React, { useState, useEffect } from "react";
import { collection, addDoc, updateDoc, doc } from "firebase/firestore";
import { db } from "../../../firebaseConfig"; // Adjust path as necessary

function VolumeForm({ volume, onClose, onSave }) {
  const [title, setTitle] = useState("");
  const [year, setYear] = useState("");
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (volume) {
      setTitle(volume.title);
      setYear(volume.year);
      setOrder(volume.order);
    } else {
      // For new volumes, set default values
      setTitle("");
      setYear(new Date().getFullYear().toString()); // Default to current year
      setOrder(""); // Let user define order or implement auto-increment later
    }
  }, [volume]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const volumeData = {
        title,
        year: parseInt(year), // Ensure year is a number
        order: parseInt(order), // Ensure order is a number
      };

      if (volume) {
        // Update existing volume
        await updateDoc(doc(db, "journalVolumes", volume.id), volumeData);
      } else {
        // Add new volume
        await addDoc(collection(db, "journalVolumes"), volumeData);
      }
      onSave(); // Refresh parent list
      onClose(); // Close modal
    } catch (err) {
      console.error("Error saving volume:", err);
      setError("Failed to save volume. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
        <h3 className="text-lg font-bold mb-4 text-slate-800">
          {volume ? "Edit Volume" : "Add New Volume"}
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="volumeTitle"
              className="block text-sm font-medium text-gray-700"
            >
              Title (e.g., Volume 1)
            </label>
            <input
              type="text"
              id="volumeTitle"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-sky-500 focus:border-sky-500"
              required
            />
          </div>
          <div>
            <label
              htmlFor="volumeYear"
              className="block text-sm font-medium text-gray-700"
            >
              Year
            </label>
            <input
              type="number"
              id="volumeYear"
              value={year}
              onChange={(e) => setYear(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-sky-500 focus:border-sky-500"
              required
            />
          </div>
          <div>
            <label
              htmlFor="volumeOrder"
              className="block text-sm font-medium text-gray-700"
            >
              Order (for sorting)
            </label>
            <input
              type="number"
              id="volumeOrder"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-sky-500 focus:border-sky-500"
              required
            />
          </div>
          {error && <p className="text-red-500 text-sm">{error}</p>}
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-sky-600 text-white rounded-md text-sm font-medium hover:bg-sky-700 disabled:opacity-50"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Volume"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VolumeForm;
